import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {environment} from '../../environments/environment';
import {HeaderService} from './header.service';

@Injectable()
export class CategoryService extends HeaderService {


    createCategory(data): Observable<any> {
        return this.http.post(environment.apiBaseUrl + 'create-product-category',
            JSON.stringify({category: data}),
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }
    updateCategory(data, id): Observable<any> {
        return this.http.put(environment.apiBaseUrl + 'update-product-category/' + id,
            JSON.stringify({category: data}),
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }
    deleteCategory(id): Observable<any> {
        return this.http.delete(environment.apiBaseUrl + 'delete-product-category/' + id,
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }
    getCategories(page: number): Observable<any> {
        return this.http.get(environment.apiBaseUrl + 'categories/'+ page,
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }
    getCategory(id): Observable<any> {
        return this.http.get(environment.apiBaseUrl + 'category/' + id,
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

}



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/services/category.service.ts